import { chakra, HTMLChakraProps } from '@chakra-ui/react'

export const Logo = (props: HTMLChakraProps<'img'>) => (
  <chakra.img src="/img/logo-white-tiff50.png" height="45px" alt="TIFF logo"/>
)
